import React, { ReactNode, forwardRef } from 'react';
import { cn } from '@/lib/utils';
import { EMPTY_STATE } from '@/lib/design-tokens';

interface EmptyStateProps {
  titulo: string;
  descricao?: string;
  acao?: ReactNode;
  className?: string;
}

/**
 * Componente para exibir estados vazios de forma consistente.
 * Usado quando não há dados para exibir ou acesso restrito.
 */
export const EmptyState = forwardRef<HTMLDivElement, EmptyStateProps>(
  function EmptyState({ titulo, descricao, acao, className }, ref) {
    return (
      <div ref={ref} className={cn(EMPTY_STATE.container, className)}>
        <h3 className={EMPTY_STATE.title}>{titulo}</h3>
        {descricao && (
          <p className={EMPTY_STATE.description}>{descricao}</p>
        )}
        {acao && (
          <div className={EMPTY_STATE.action}>
            {acao}
          </div>
        )}
      </div>
    );
  }
);
